import React from "react";
import { motion } from "framer-motion";
import { Flame } from "lucide-react";

const MILE_DAYS = [1, 3, 7, 14, 30, 60, 90, 180, 365];

export default function StreakRing({ days = 0 }) {
  const next = MILE_DAYS.find((d) => d > days) || (days + 30);
  const prev = [...MILE_DAYS].reverse().find((d) => d <= days) || 0;
  const span = Math.max(1, next - prev);
  const pct = Math.min(1, (days - prev) / span);
  const R = 54;
  const C = 2 * Math.PI * R;
  // glow intensity grows with streak length
  const glow = Math.min(0.55, 0.12 + days * 0.015);

  return (
    <div className="rounded-3xl bg-brand-navy text-white p-7 shadow-soft" data-testid="streak-ring-card">
      <p className="uppercase tracking-[0.2em] text-[11px] text-brand-teal mb-5">Smoke-free streak</p>
      <div className="flex items-center gap-6">
        <div className="relative w-32 h-32 shrink-0">
          <svg className="w-full h-full -rotate-90" viewBox="0 0 120 120">
            <circle cx="60" cy="60" r={R} fill="none" stroke="rgba(255,255,255,0.12)" strokeWidth="8" />
            <motion.circle
              cx="60" cy="60" r={R} fill="none" stroke="#00D1C2" strokeWidth="8" strokeLinecap="round"
              strokeDasharray={C}
              initial={{ strokeDashoffset: C }}
              animate={{ strokeDashoffset: C * (1 - pct) }}
              transition={{ duration: 1.1, ease: "easeOut" }}
              style={{ filter: `drop-shadow(0 0 ${6 + days * 0.5}px rgba(0,209,194,${glow}))` }}
            />
          </svg>
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <span className="font-serif text-4xl leading-none">{days}</span>
            <span className="text-[11px] text-white/60 mt-1">{days === 1 ? "day" : "days"}</span>
          </div>
        </div>
        <div className="min-w-0">
          <p className="flex items-center gap-1.5 text-brand-gold-light text-sm font-medium">
            <Flame className="w-4 h-4" /> {days === 0 ? "Your streak starts today" : "Burning bright"}
          </p>
          <p className="text-white/75 text-sm mt-2 leading-relaxed">
            {days >= next
              ? "You've passed every marker — keep going."
              : `${next - days} ${next - days === 1 ? "day" : "days"} to your ${next}-day mark.`}
          </p>
          <p className="text-white/45 text-xs mt-3">Every day you keep is grace made visible.</p>
        </div>
      </div>
    </div>
  );
}
